import React from 'react';
import { ReferenceField } from 'react-admin';

import NameField from '../components/NameField';

const CreatedByReferenceField = props => {
  return ( props.record && props.record.createdBy ?
        <ReferenceField source="createdBy.id" reference="users" {...props}>
            <NameField />
        </ReferenceField>
    : <>-</>
)};

CreatedByReferenceField.defaultProps = {
    source: 'createdBy.id',
    label: 'resources.users.fields.createdBy',
    addLabel: true,
};

export default CreatedByReferenceField;
